module.exports = __webpack_public_path__ + "images/emoji/point_up.311c8bc70b7d3202635e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/point_up.png
// module id = Mx23
// module chunks = 14